(function () {
    'use strict';

    var serviceId = 'storageService';
    angular.module('inoApp').factory(serviceId, ['$window', storageService]);

    // Base storage/session service. It should probably never be used directly by controllers. If you ever do it, carefully consider another way.
    // Currently it only wraps html5 sessionStorage object.

    function storageService($window) {
        var sessionStorage = $window.sessionStorage;

        var service = {
            clear: clear,
            getItem: getItem,
            removeItem: removeItem,
            setItem: setItem
        };

        return service;

        function clear() {
            sessionStorage.clear();
        }

        function getItem(key) {
            var dateTimeReviver = function (key, value) {
                if (typeof value === 'string') {
                    var regexValues = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+\-])(\d{2}):(\d{2}))$/.exec(value);
                    if (regexValues) {
                        // JSON.stringify converts dates to UTC so parse them back
                        return new Date(Date.UTC(+regexValues[1], +regexValues[2] - 1, +regexValues[3], +regexValues[4], +regexValues[5], +regexValues[6]));
                    }
                }
                return value;
            };
            var value = sessionStorage.getItem(JSON.stringify(key));

            return JSON.parse(value, dateTimeReviver);
        }

        function removeItem(key) {
            sessionStorage.removeItem(JSON.stringify(key));
        }

        function setItem(key, value) {
            sessionStorage.setItem(JSON.stringify(key), JSON.stringify(value));
        }
    }
})();